import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import { createPortionLabelSelector } from 'Components/Worksheets/PsdSieveAnalysisWorksheet/Helpers';
import React from 'react';
import { useSelector } from 'react-redux';
import { Field, NumericInput, TextOutput } from '../../../../../../Core';
import { NamePrefixModifier, withInjectedProps } from '../../../../../../Core/InjectedPropsContext';
import { ListFieldSection } from '../../../../../../Layout';
import { WorksheetBalanceFieldSet } from '../../../../../Core/WorksheetEquipment';

let SubspecimenDryMassesSection: React.FC<IWorksheetComponent> = ({ namePrefix, createWorksheetSelector }) => {
  const subsampledPortionLabel = useSelector(createPortionLabelSelector(createWorksheetSelector!, `${namePrefix}`));

  return (
    <>
      <ListFieldSection>
        <Field input={<TextOutput />} name="Masses.DryMass" label={`${subsampledPortionLabel} Dry Mass`} />
      </ListFieldSection>
      <NamePrefixModifier appendNamePrefix="Subspecimen.Masses.MassMeasurement">
        <ListFieldSection>
          <WorksheetBalanceFieldSet label="Balance" name="Equipment.Balance" copyTo={['Equipment.DryMassBalance']} />
          <Field input={<NumericInput />} name="TareMass" label="Tare Mass" />
          <Field input={<NumericInput />} name="TareAndDryMass" label="Tare and Subspecimen Dry Mass" />
          <Field input={<TextOutput />} name="DryMass" label="Subspecimen Dry Mass" />
        </ListFieldSection>
      </NamePrefixModifier>
    </>
  );
};

SubspecimenDryMassesSection = withInjectedProps(SubspecimenDryMassesSection);

export { SubspecimenDryMassesSection };
export default SubspecimenDryMassesSection;
